import { render, staticRenderFns } from "./SuppliesWrapper.vue?vue&type=template&id=da46a790&"
import script from "./SuppliesWrapper.vue?vue&type=script&lang=ts&"
export * from "./SuppliesWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports